import { render } from "./CadastrarTipoOleo.vue?vue&type=template&id=ec74bca2&scoped=true"
import script from "./CadastrarTipoOleo.vue?vue&type=script&lang=js"
export * from "./CadastrarTipoOleo.vue?vue&type=script&lang=js"

import "./CadastrarTipoOleo.vue?vue&type=style&index=0&id=ec74bca2&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec74bca2"]])

export default __exports__